<template>
  <v-container fluid>
    <app-toolbar
      :dateonefromurl="datesfromURL[0]"
      :datetwofromurl="datesfromURL[1]"
      @datesUpdate="datesUpdate"
    />
    <app-filters
      :filters="filters"
      :selects="reportingDataUpdate.selects"
      :selectedfromtable="selectedfromtable"
      @filtersUpdate="filtersUpdate"
    />
    <app-charts
      :reporting-data="reportingDataUpdate.perDay"
      :loading="loading"
      :colors="colors"
      :time-unit="'datetime'"
    />
    <app-per-criteria
      style="padding-top: 30px"
      :reporting-data="reportingData.perCriteria"
      :reporting-data-p-m="reportingDataPM.perCriteria"
      :reporting-data-p-p-m="reportingDataPPM.perCriteria"
      :reporting-data-p-p-p-m="reportingDataPPPM.perCriteria"
      :reporting-data-update="reportingDataUpdate.perCriteria"
      :loading="loading"
      :cats="cats"
      :period="period"
      @perCriteriaUpdate="perCriteriaUpdate"
    />
  </v-container>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'
  import Toolbar from '@/components/reporting/toolbar.vue'
  import Filters from '@/components/reporting/filters.vue'
  import Charts from './charts/index.vue'
  import PerCriteria from './perCriterias/index.vue'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      AppFilters: Filters,
      AppToolbar: Toolbar,
      AppCharts: Charts,
      AppPerCriteria: PerCriteria
    },
    data() {
      return {
        loading: false,
        dates: {},
        period: {},
        sourceFilter: [],
        filters: {
          auction_type: [],
          site: [],
          placement: []
        },
        reportingDataUpdate: {
          perCriteria: {
            auction_type: [],
            site: [],
            placement: []
          },
          perDay: []
        },
        reportingData: {
          perCriteria: {
            auction_type: [],
            site: [],
            placement: []
          },
          perDay: [],
          dates: []
        },
        reportingDataPM: {
          perCriteria: {
            auction_type: [],
            site: [],
            placement: []
          },
          perDay: [],
          dates: []
        },
        reportingDataPPM: {
          perCriteria: {
            auction_type: [],
            site: [],
            placement: []
          },
          perDay: [],
          dates: []
        },
        reportingDataPPPM: {
          perCriteria: {
            auction_type: [],
            site: [],
            placement: []
          },
          perDay: [],
          dates: []
        },
        dataSync: false,
        customerId: 0,
        colors: [],
        selectedfromtable: [],
        datesfromURL: []
      }
    },
    computed: {
      ...mapGetters(['appCustomer']),
      cats() {
        return Object.keys(this.reportingDataUpdate.perCriteria)
      }
    },
    watch: {
      appCustomer() {
        this.filters = Object.assign(
          {},
          {
            auction_type: [],
            site: [],
            placement: []
          }
        )
        this.generatePreviousMonthsData()
        this.getDataFromApi()
      }
    },
    created() {
      this.generatePreviousMonthsData()
      this.generateFilterFromLink()
    },
    methods: {
      async generatePreviousMonthsData() {
        var dates = []
        dates = [moment().startOf('month'), moment().endOf('month')]
        dates = [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]
        const payloadCM = {
          timeOffset: this.getTimeZone(),
          filters: this.filters,
          dates: this.unixDates(dates),
          customerId: this.appCustomer.id,
          sites: this.filters['site'].length > 0 ? this.filters['site'] : []
        }
        dates = [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
        dates = [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]
        const payloadPM = {
          timeOffset: this.getTimeZone(),
          filters: this.filters,
          dates: this.unixDates(dates),
          customerId: this.appCustomer.id,
          sites: this.filters['site'].length > 0 ? this.filters['site'] : []
        }
        dates = [
          moment().subtract(2, 'month').startOf('month'),
          moment().subtract(2, 'month').endOf('month')
        ]
        dates = [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]
        const payloadPPM = {
          timeOffset: this.getTimeZone(),
          filters: this.filters,
          dates: this.unixDates(dates),
          customerId: this.appCustomer.id,
          sites: this.filters['site'].length > 0 ? this.filters['site'] : []
        }
        dates = [
          moment().subtract(3, 'month').startOf('month'),
          moment().subtract(3, 'month').endOf('month')
        ]
        dates = [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')]
        const payloadPPPM = {
          timeOffset: this.getTimeZone(),
          filters: this.filters,
          dates: this.unixDates(dates),
          customerId: this.appCustomer.id,
          sites: this.filters['site'].length > 0 ? this.filters['site'] : []
        }
        try {
          const response = await axios.post(
            `/api/invoicing-reporting`,
            payloadCM
          )
          this.reportingData = response.data
          this.loading = false
        } catch (e) {
          console.log(e)
        }
        try {
          const response = await axios.post(
            `/api/invoicing-reporting`,
            payloadPM
          )
          this.reportingDataPM = response.data
          this.loading = false
        } catch (e) {
          console.log(e)
        }
        try {
          const response = await axios.post(
            `/api/invoicing-reporting`,
            payloadPPM
          )
          this.reportingDataPPM = response.data
          this.loading = false
        } catch (e) {
          console.log(e)
        }
        try {
          const response = await axios.post(
            `/api/invoicing-reporting`,
            payloadPPPM
          )
          this.reportingDataPPPM = response.data
          this.loading = false
        } catch (e) {
          console.log(e)
        }
      },
      unixDates(dates) {
        return [
          moment(dates[0]).startOf('day').format('x'),
          moment(dates[1])
            .startOf('day')
            .add(1, 'days')
            .subtract(1, 'ms')
            .format('x')
        ]
      },
      datesUpdate(dates) {
        if (dates[0] > dates[1]) {
          const dateswap = dates[0]
          dates[0] = dates[1]
          dates[1] = dateswap
        }
        this.period = dates
        this.dates = this.unixDates(dates)
        this.buildLink(this.filters)
        this.getDataFromApi()
        this.dataSync = true
      },
      async filtersUpdate(foo) {
        this.filters = Object.assign({}, foo)
        this.buildLink(foo)
        if (this.dataSync) await this.getDataFromApi()
        this.dataSync = true
      },
      perCriteriaUpdate(foo) {
        this.selectedfromtable = foo
        this.filters[foo.category] = [foo.id]
        if (this.dataSync) this.getDataFromApi()
        this.dataSync = true
      },
      resetColors() {
        this.colors = []
        this.colors = ['#2E418A', '#00ead3', '#fc8f00']
      },
      getTimeZone() {
        var offset = new Date().getTimezoneOffset(),
          o = Math.abs(offset)
        return (
          (offset < 0 ? '+' : '-') +
          ('00' + Math.floor(o / 60)).slice(-2) +
          ':' +
          ('00' + (o % 60)).slice(-2)
        )
      },
      async getDataFromApi() {
        this.loading = true
        const payload = {
          timeOffset: this.getTimeZone(),
          filters: this.filters,
          dates: this.dates,
          customerId: this.appCustomer.id,
          sites: this.filters['site'].length > 0 ? this.filters['site'] : []
        }
        try {
          const response = await axios.post(`/api/invoicing-reporting`, payload)
          this.reportingDataUpdate = response.data
          this.reportingData = response.data
          this.loading = false
        } catch (e) {
          console.log(e)
        }
      },
      buildLink(filters) {
        var d1 = ''
        var d2 = ''
        if (this.$route.name == 'billing_reporting') {
          d1 = moment().startOf('month')
          d2 = moment().startOf('day')
        }
        if (this.$route.name == 'pbs_reporting') {
          d1 = moment().startOf('day').subtract(6, 'days')
          d1 = moment().startOf('day').subtract(0, 'days')
        }
        var testDates = this.unixDates([d1, d2])
        if (
          filters['auction_type'].length > 0 ||
          filters['site'].length > 0 ||
          filters['placement'].length > 0 ||
          ((testDates[0] != this.dates[0] || testDates[1] != this.dates[1]) &&
            this.dates.length > 0)
        ) {
          var routepath = ''
          if (
            this.$route.path !=
            '/billing-reporting/filters/' + this.appCustomer.id
          ) {
            routepath = 'billing-reporting/filters/' + this.appCustomer.id
          }
          var route = ''

          route = route + '?date0=' + this.dates[0] + '&date1=' + this.dates[1]
          if (filters['auction_type'].length > 0) {
            var auctions = filters['auction_type'].join()
            route = route + '&auction_type=' + auctions
          }

          if (filters['site'].length > 0) {
            var sites = filters['site'].join()
            route = route + '&sites=' + sites
            if (filters['placement'].length > 0) {
              var placements = filters['placement'].join()
              route = route + '&placements=' + placements
            }
          }
          if (this.$route.fullPath != this.$route.path + routepath + route) {
            this.$router.push(routepath + route)
          }
        }
      },
      generateFilterFromLink() {
        if (
          this.$route.path ==
          '/billing-reporting/filters/' + this.appCustomer.id
        ) {
          this.datesfromURL[0] = this.$route.query.date0
          this.datesfromURL[1] = this.$route.query.date1
          if (
            this.$route.query.auction_type != undefined ||
            this.$route.query.sites != undefined ||
            this.$route.query.placements != undefined
          ) {
            var foo = []
            if (this.$route.query.auction_type != undefined) {
              var auctions = this.$route.query.auction_type.split(',')
              foo['auction_type'] = auctions
              this.filters['auction_type'] = foo['auction_type']
            }
            if (this.$route.query.sites != undefined) {
              var sites = this.$route.query.sites.split(',')
              foo['site'] = sites
              this.filters['site'] = foo['site']
            }
            if (this.$route.query.placements != undefined) {
              var placements = this.$route.query.placements.split(',')
              foo['placement'] = placements
              this.filters['placement'] = foo['placement']
            }
          }
        } else {
          if (this.$route.path != '/billing-reporting') {
            this.$router.push({ name: 'billing_reporting' })
          }
        }
        //this.action = 'build'
      }
    }
  }
</script>
